import { z } from 'zod';
import { IChildren } from './IChildren';
import { IDocument } from './IDocument';
import { IMarriage } from './IMarriage';
import { IInheritHasPerson } from './IPerson';
import { IPersonHasDocument } from './IPersonHasDocument';
import { ILegalClient } from './ILegalClient';

export const inheritSchema = z.object({
  idInherit: z.number(),
  idLegalTransaction: z.number(),
  idPerson: z.number(),
  hasTestament: z.boolean(),
  // ARNOtop Sync
  syncWithArnoTop: z.boolean().optional(),
});

export type IInherit = z.infer<typeof inheritSchema>;

export interface IInheritFullObject extends IInherit {
  PersonArray: IInheritHasPerson[];
  MarriageArray: IMarriage[];
  ChildrenArray: IChildren[];
  PersonHasDocument: IPersonHasDocument[];
  FamilyTreeData?: IDocument;
  LegalClientArray: ILegalClient[];
}
